{
  "productCatalog": "Product Catalog",
  "hfInferenceForGenAI": "Use Hugging Face Inference for Generative AI",
  "multilingualAISearch": "Multilingual AI Search",
  "backgroundSyncEnabled": "Mobile Assets Background Sync Enabled",
  "futureVision": "Future Vision",
  "companiesContacts": "Companies & Contacts",
  "autoSave": "Procedure Auto-Save",
  "createPmWorkOrder": "Create Work Order from PM Event",
  "assetsCalendarView": "Assets Calendar View"
}
